export default {
  getAmountOfModuleOne          : state => state.amountOfModuleOne,
  getAmountOfModuleTwo          : state => state.amountOfModuleTwo,
  getAmountOfModuleTwoOne       : state => state.amountOfModuleTwoOne,
  getAmountOfModuleTwoTwoPercent: state => state.amountOfModuleTwoTwoPercent,
  getAmountOfModuleThree        : state => state.amountOfModuleThree,
  getAmountOfModuleFour         : state => state.amountOfModuleFour,
  getAmountOfModuleFive         : state => state.amountOfModuleFive,
  getAmountOfModuleSix          : state => state.amountOfModuleSix,
  getAmountOfConsumablesByMonth : state => state.amountOfConsumablesByMonth,
  getAmountOfEquipmentsByMonth  : state => state.amountOfEquipmentsByMonth,
  getAmountOfUniformsByMonth    : state => state.amountOfUniformsByMonth,
  getAmountOfUtensilsByMonth    : state => state.amountOfUtensilsByMonth,
  getAnalyticalWorksheet        : state => state.analyticalWorksheet,
  getBudget                     : state => state.budget,
  getBudgetFinalized            : state => state.getBudgetFinalized,
  getHasChange                  : state => state.hasChange
}




// WEBPACK FOOTER //
// ./src/store/modules/budget/getters.js